import apiRequest, { API_BASE_URL } from './client';

const qs = (params) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

// Rapport en JSON (pour l'affichage tableau). `endpoint` : /reports/ (company/
// superadmin, defaut) ou /reports/supervisor/ (portail superviseur, memes
// query params, restreint a ses banks cote backend).
export const fetchReport = (params, endpoint = '/reports/') => apiRequest(`${endpoint}?${qs(params)}`);

// Telecharge le rapport dans un format fichier (csv | xlsx | pdf).
export const downloadReport = async (params, exportFmt, endpoint = '/reports/') => {
  const url = `${API_BASE_URL}${endpoint}?${qs({ ...params, export: exportFmt })}`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`Export impossible (${res.status})`);
  const blob = await res.blob();
  const disp = res.headers.get('Content-Disposition') || '';
  const match = disp.match(/filename="?([^"]+)"?/);
  const name = match ? match[1] : `rapport.${exportFmt}`;

  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(a.href);
};
